// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "dispatch_group/v1/service.proto" (package "dispatch_group.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Dispatcher } from "./dispatch_group.js";
import { DispatchGroupDeliveryPoint } from "./dispatch_group.js";
import { DispatchIndicator } from "./dispatch_group.js";
import { DispatchGroupGridService } from "./dispatch_group.js";
import { FieldMask } from "../../google/protobuf/field_mask.js";
import { PaginationResponse } from "../../common/v1/common.js";
import { SortOptions } from "./common.js";
import { PaginationRequest } from "../../common/v1/common.js";
import { DispatchGroupFilter } from "./common.js";
import { HydrationOptions } from "./common.js";
import { DispatchGroup } from "./dispatch_group.js";
// @generated message type with reflection information, may provide speed optimized methods
class CreateDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.CreateDispatchGroupRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tso_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dispatcher_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.tsoId = "";
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string tso_id */ 2:
                    message.tsoId = reader.string();
                    break;
                case /* string tenant_id */ 3:
                    message.tenantId = reader.string();
                    break;
                case /* optional string dispatcher_id */ 4:
                    message.dispatcherId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string tso_id = 2; */
        if (message.tsoId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tsoId);
        /* string tenant_id = 3; */
        if (message.tenantId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenantId);
        /* optional string dispatcher_id = 4; */
        if (message.dispatcherId !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.dispatcherId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.CreateDispatchGroupRequest
 */
export const CreateDispatchGroupRequest = new CreateDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.CreateDispatchGroupResponse", [
            { no: 1, name: "dispatch_group", kind: "message", T: () => DispatchGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroup dispatch_group */ 1:
                    message.dispatchGroup = DispatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.dispatchGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroup dispatch_group = 1; */
        if (message.dispatchGroup)
            DispatchGroup.internalBinaryWrite(message.dispatchGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.CreateDispatchGroupResponse
 */
export const CreateDispatchGroupResponse = new CreateDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.GetDispatchGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* dispatch_group.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* dispatch_group.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.GetDispatchGroupRequest
 */
export const GetDispatchGroupRequest = new GetDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.GetDispatchGroupResponse", [
            { no: 1, name: "dispatch_group", kind: "message", T: () => DispatchGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroup dispatch_group */ 1:
                    message.dispatchGroup = DispatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.dispatchGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroup dispatch_group = 1; */
        if (message.dispatchGroup)
            DispatchGroup.internalBinaryWrite(message.dispatchGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.GetDispatchGroupResponse
 */
export const GetDispatchGroupResponse = new GetDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchGroupsRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchGroupsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => DispatchGroupFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 3, name: "sort", kind: "message", T: () => SortOptions },
            { no: 4, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroupFilter filter */ 1:
                    message.filter = DispatchGroupFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* common.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* dispatch_group.v1.SortOptions sort */ 3:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* dispatch_group.v1.HydrationOptions hydration */ 4:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroupFilter filter = 1; */
        if (message.filter)
            DispatchGroupFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.SortOptions sort = 3; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.HydrationOptions hydration = 4; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchGroupsRequest
 */
export const ListDispatchGroupsRequest = new ListDispatchGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchGroupsResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchGroupsResponse", [
            { no: 1, name: "dispatch_groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchGroup },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroups = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated dispatch_group.v1.DispatchGroup dispatch_groups */ 1:
                    message.dispatchGroups.push(DispatchGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated dispatch_group.v1.DispatchGroup dispatch_groups = 1; */
        for (let i = 0; i < message.dispatchGroups.length; i++)
            DispatchGroup.internalBinaryWrite(message.dispatchGroups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchGroupsResponse
 */
export const ListDispatchGroupsResponse = new ListDispatchGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatchGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dispatch_group", kind: "message", T: () => DispatchGroup },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* dispatch_group.v1.DispatchGroup dispatch_group */ 2:
                    message.dispatchGroup = DispatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.dispatchGroup);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* dispatch_group.v1.DispatchGroup dispatch_group = 2; */
        if (message.dispatchGroup)
            DispatchGroup.internalBinaryWrite(message.dispatchGroup, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatchGroupRequest
 */
export const UpdateDispatchGroupRequest = new UpdateDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatchGroupResponse", [
            { no: 1, name: "dispatch_group", kind: "message", T: () => DispatchGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroup dispatch_group */ 1:
                    message.dispatchGroup = DispatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.dispatchGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroup dispatch_group = 1; */
        if (message.dispatchGroup)
            DispatchGroup.internalBinaryWrite(message.dispatchGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatchGroupResponse
 */
export const UpdateDispatchGroupResponse = new UpdateDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DeleteDispatchGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DeleteDispatchGroupRequest
 */
export const DeleteDispatchGroupRequest = new DeleteDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DeleteDispatchGroupResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DeleteDispatchGroupResponse
 */
export const DeleteDispatchGroupResponse = new DeleteDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.RestoreDispatchGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.RestoreDispatchGroupRequest
 */
export const RestoreDispatchGroupRequest = new RestoreDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.RestoreDispatchGroupResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.RestoreDispatchGroupResponse
 */
export const RestoreDispatchGroupResponse = new RestoreDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddGridServiceToDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.AddGridServiceToDispatchGroupRequest", [
            { no: 1, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "market_access_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "from", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "to", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroupId = "";
        message.gridServiceId = "";
        message.marketAccessId = "";
        message.from = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dispatch_group_id */ 1:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string grid_service_id */ 2:
                    message.gridServiceId = reader.string();
                    break;
                case /* string market_access_id */ 3:
                    message.marketAccessId = reader.string();
                    break;
                case /* uint64 from */ 4:
                    message.from = reader.uint64().toBigInt();
                    break;
                case /* optional uint64 to */ 5:
                    message.to = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string dispatch_group_id = 1; */
        if (message.dispatchGroupId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string grid_service_id = 2; */
        if (message.gridServiceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.gridServiceId);
        /* string market_access_id = 3; */
        if (message.marketAccessId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.marketAccessId);
        /* uint64 from = 4; */
        if (message.from !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.from);
        /* optional uint64 to = 5; */
        if (message.to !== undefined)
            writer.tag(5, WireType.Varint).uint64(message.to);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.AddGridServiceToDispatchGroupRequest
 */
export const AddGridServiceToDispatchGroupRequest = new AddGridServiceToDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddGridServiceToDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.AddGridServiceToDispatchGroupResponse", [
            { no: 1, name: "grid_service", kind: "message", T: () => DispatchGroupGridService }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroupGridService grid_service */ 1:
                    message.gridService = DispatchGroupGridService.internalBinaryRead(reader, reader.uint32(), options, message.gridService);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroupGridService grid_service = 1; */
        if (message.gridService)
            DispatchGroupGridService.internalBinaryWrite(message.gridService, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.AddGridServiceToDispatchGroupResponse
 */
export const AddGridServiceToDispatchGroupResponse = new AddGridServiceToDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGridServiceFromDispatchGroupRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.RemoveGridServiceFromDispatchGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.RemoveGridServiceFromDispatchGroupRequest
 */
export const RemoveGridServiceFromDispatchGroupRequest = new RemoveGridServiceFromDispatchGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGridServiceFromDispatchGroupResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.RemoveGridServiceFromDispatchGroupResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.RemoveGridServiceFromDispatchGroupResponse
 */
export const RemoveGridServiceFromDispatchGroupResponse = new RemoveGridServiceFromDispatchGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatchGroupGridServiceRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatchGroupGridServiceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "grid_service", kind: "message", T: () => DispatchGroupGridService },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* dispatch_group.v1.DispatchGroupGridService grid_service */ 2:
                    message.gridService = DispatchGroupGridService.internalBinaryRead(reader, reader.uint32(), options, message.gridService);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* dispatch_group.v1.DispatchGroupGridService grid_service = 2; */
        if (message.gridService)
            DispatchGroupGridService.internalBinaryWrite(message.gridService, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatchGroupGridServiceRequest
 */
export const UpdateDispatchGroupGridServiceRequest = new UpdateDispatchGroupGridServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatchGroupGridServiceResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatchGroupGridServiceResponse", [
            { no: 1, name: "grid_service", kind: "message", T: () => DispatchGroupGridService }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroupGridService grid_service */ 1:
                    message.gridService = DispatchGroupGridService.internalBinaryRead(reader, reader.uint32(), options, message.gridService);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroupGridService grid_service = 1; */
        if (message.gridService)
            DispatchGroupGridService.internalBinaryWrite(message.gridService, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatchGroupGridServiceResponse
 */
export const UpdateDispatchGroupGridServiceResponse = new UpdateDispatchGroupGridServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchGroupGridServicesRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchGroupGridServicesRequest", [
            { no: 1, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 5, name: "sort", kind: "message", T: () => SortOptions },
            { no: 6, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroupId = "";
        message.gridServiceId = "";
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dispatch_group_id */ 1:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string grid_service_id */ 2:
                    message.gridServiceId = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 4:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* dispatch_group.v1.SortOptions sort */ 5:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* dispatch_group.v1.HydrationOptions hydration */ 6:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string dispatch_group_id = 1; */
        if (message.dispatchGroupId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string grid_service_id = 2; */
        if (message.gridServiceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.gridServiceId);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* common.v1.PaginationRequest pagination = 4; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.SortOptions sort = 5; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.HydrationOptions hydration = 6; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchGroupGridServicesRequest
 */
export const ListDispatchGroupGridServicesRequest = new ListDispatchGroupGridServicesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchGroupGridServicesResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchGroupGridServicesResponse", [
            { no: 1, name: "grid_services", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchGroupGridService },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServices = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated dispatch_group.v1.DispatchGroupGridService grid_services */ 1:
                    message.gridServices.push(DispatchGroupGridService.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated dispatch_group.v1.DispatchGroupGridService grid_services = 1; */
        for (let i = 0; i < message.gridServices.length; i++)
            DispatchGroupGridService.internalBinaryWrite(message.gridServices[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchGroupGridServicesResponse
 */
export const ListDispatchGroupGridServicesResponse = new ListDispatchGroupGridServicesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDispatchIndicatorRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.CreateDispatchIndicatorRequest", [
            { no: 1, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "active_power_real_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "assigned_capacity_up_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "assigned_capacity_down_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "power_request_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "baseline_real_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "baseline_assume_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServiceId = "";
        message.timestamp = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string grid_service_id */ 1:
                    message.gridServiceId = reader.string();
                    break;
                case /* uint64 timestamp */ 2:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                case /* optional int64 active_power_real_w */ 3:
                    message.activePowerRealW = reader.int64().toBigInt();
                    break;
                case /* optional int64 assigned_capacity_up_w */ 5:
                    message.assignedCapacityUpW = reader.int64().toBigInt();
                    break;
                case /* optional int64 assigned_capacity_down_w */ 6:
                    message.assignedCapacityDownW = reader.int64().toBigInt();
                    break;
                case /* optional int64 power_request_w */ 7:
                    message.powerRequestW = reader.int64().toBigInt();
                    break;
                case /* optional int64 baseline_real_w */ 11:
                    message.baselineRealW = reader.int64().toBigInt();
                    break;
                case /* optional int64 baseline_assume_w */ 12:
                    message.baselineAssumeW = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string grid_service_id = 1; */
        if (message.gridServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.gridServiceId);
        /* uint64 timestamp = 2; */
        if (message.timestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestamp);
        /* optional int64 active_power_real_w = 3; */
        if (message.activePowerRealW !== undefined)
            writer.tag(3, WireType.Varint).int64(message.activePowerRealW);
        /* optional int64 assigned_capacity_up_w = 5; */
        if (message.assignedCapacityUpW !== undefined)
            writer.tag(5, WireType.Varint).int64(message.assignedCapacityUpW);
        /* optional int64 assigned_capacity_down_w = 6; */
        if (message.assignedCapacityDownW !== undefined)
            writer.tag(6, WireType.Varint).int64(message.assignedCapacityDownW);
        /* optional int64 power_request_w = 7; */
        if (message.powerRequestW !== undefined)
            writer.tag(7, WireType.Varint).int64(message.powerRequestW);
        /* optional int64 baseline_real_w = 11; */
        if (message.baselineRealW !== undefined)
            writer.tag(11, WireType.Varint).int64(message.baselineRealW);
        /* optional int64 baseline_assume_w = 12; */
        if (message.baselineAssumeW !== undefined)
            writer.tag(12, WireType.Varint).int64(message.baselineAssumeW);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.CreateDispatchIndicatorRequest
 */
export const CreateDispatchIndicatorRequest = new CreateDispatchIndicatorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDispatchIndicatorResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.CreateDispatchIndicatorResponse", [
            { no: 1, name: "dispatch_indicator", kind: "message", T: () => DispatchIndicator }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchIndicator dispatch_indicator */ 1:
                    message.dispatchIndicator = DispatchIndicator.internalBinaryRead(reader, reader.uint32(), options, message.dispatchIndicator);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchIndicator dispatch_indicator = 1; */
        if (message.dispatchIndicator)
            DispatchIndicator.internalBinaryWrite(message.dispatchIndicator, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.CreateDispatchIndicatorResponse
 */
export const CreateDispatchIndicatorResponse = new CreateDispatchIndicatorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDispatchIndicatorRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.GetDispatchIndicatorRequest", [
            { no: 1, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServiceId = "";
        message.timestamp = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string grid_service_id */ 1:
                    message.gridServiceId = reader.string();
                    break;
                case /* uint64 timestamp */ 2:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string grid_service_id = 1; */
        if (message.gridServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.gridServiceId);
        /* uint64 timestamp = 2; */
        if (message.timestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.GetDispatchIndicatorRequest
 */
export const GetDispatchIndicatorRequest = new GetDispatchIndicatorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDispatchIndicatorResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.GetDispatchIndicatorResponse", [
            { no: 1, name: "dispatch_indicator", kind: "message", T: () => DispatchIndicator }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchIndicator dispatch_indicator */ 1:
                    message.dispatchIndicator = DispatchIndicator.internalBinaryRead(reader, reader.uint32(), options, message.dispatchIndicator);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchIndicator dispatch_indicator = 1; */
        if (message.dispatchIndicator)
            DispatchIndicator.internalBinaryWrite(message.dispatchIndicator, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.GetDispatchIndicatorResponse
 */
export const GetDispatchIndicatorResponse = new GetDispatchIndicatorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchIndicatorsRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchIndicatorsRequest", [
            { no: 1, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp_after", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "timestamp_before", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 5, name: "sort", kind: "message", T: () => SortOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServiceId = "";
        message.timestampAfter = 0n;
        message.timestampBefore = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string grid_service_id */ 1:
                    message.gridServiceId = reader.string();
                    break;
                case /* uint64 timestamp_after */ 2:
                    message.timestampAfter = reader.uint64().toBigInt();
                    break;
                case /* uint64 timestamp_before */ 3:
                    message.timestampBefore = reader.uint64().toBigInt();
                    break;
                case /* common.v1.PaginationRequest pagination */ 4:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* dispatch_group.v1.SortOptions sort */ 5:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string grid_service_id = 1; */
        if (message.gridServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.gridServiceId);
        /* uint64 timestamp_after = 2; */
        if (message.timestampAfter !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestampAfter);
        /* uint64 timestamp_before = 3; */
        if (message.timestampBefore !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.timestampBefore);
        /* common.v1.PaginationRequest pagination = 4; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.SortOptions sort = 5; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchIndicatorsRequest
 */
export const ListDispatchIndicatorsRequest = new ListDispatchIndicatorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchIndicatorsResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchIndicatorsResponse", [
            { no: 1, name: "dispatch_indicators", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchIndicator },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchIndicators = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated dispatch_group.v1.DispatchIndicator dispatch_indicators */ 1:
                    message.dispatchIndicators.push(DispatchIndicator.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated dispatch_group.v1.DispatchIndicator dispatch_indicators = 1; */
        for (let i = 0; i < message.dispatchIndicators.length; i++)
            DispatchIndicator.internalBinaryWrite(message.dispatchIndicators[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchIndicatorsResponse
 */
export const ListDispatchIndicatorsResponse = new ListDispatchIndicatorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatchIndicatorRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatchIndicatorRequest", [
            { no: 1, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "dispatch_indicator", kind: "message", T: () => DispatchIndicator },
            { no: 4, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServiceId = "";
        message.timestamp = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string grid_service_id */ 1:
                    message.gridServiceId = reader.string();
                    break;
                case /* uint64 timestamp */ 2:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                case /* dispatch_group.v1.DispatchIndicator dispatch_indicator */ 3:
                    message.dispatchIndicator = DispatchIndicator.internalBinaryRead(reader, reader.uint32(), options, message.dispatchIndicator);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 4:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string grid_service_id = 1; */
        if (message.gridServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.gridServiceId);
        /* uint64 timestamp = 2; */
        if (message.timestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestamp);
        /* dispatch_group.v1.DispatchIndicator dispatch_indicator = 3; */
        if (message.dispatchIndicator)
            DispatchIndicator.internalBinaryWrite(message.dispatchIndicator, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 4; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatchIndicatorRequest
 */
export const UpdateDispatchIndicatorRequest = new UpdateDispatchIndicatorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatchIndicatorResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatchIndicatorResponse", [
            { no: 1, name: "dispatch_indicator", kind: "message", T: () => DispatchIndicator }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchIndicator dispatch_indicator */ 1:
                    message.dispatchIndicator = DispatchIndicator.internalBinaryRead(reader, reader.uint32(), options, message.dispatchIndicator);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchIndicator dispatch_indicator = 1; */
        if (message.dispatchIndicator)
            DispatchIndicator.internalBinaryWrite(message.dispatchIndicator, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatchIndicatorResponse
 */
export const UpdateDispatchIndicatorResponse = new UpdateDispatchIndicatorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDispatchIndicatorRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DeleteDispatchIndicatorRequest", [
            { no: 1, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServiceId = "";
        message.timestamp = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string grid_service_id */ 1:
                    message.gridServiceId = reader.string();
                    break;
                case /* uint64 timestamp */ 2:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string grid_service_id = 1; */
        if (message.gridServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.gridServiceId);
        /* uint64 timestamp = 2; */
        if (message.timestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DeleteDispatchIndicatorRequest
 */
export const DeleteDispatchIndicatorRequest = new DeleteDispatchIndicatorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDispatchIndicatorResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DeleteDispatchIndicatorResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DeleteDispatchIndicatorResponse
 */
export const DeleteDispatchIndicatorResponse = new DeleteDispatchIndicatorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddDispatchGroupDeliveryPointRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.AddDispatchGroupDeliveryPointRequest", [
            { no: 1, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "effective_from", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "effective_to", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroupId = "";
        message.deliveryPointId = "";
        message.effectiveFrom = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dispatch_group_id */ 1:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string delivery_point_id */ 2:
                    message.deliveryPointId = reader.string();
                    break;
                case /* uint64 effective_from */ 3:
                    message.effectiveFrom = reader.uint64().toBigInt();
                    break;
                case /* optional uint64 effective_to */ 4:
                    message.effectiveTo = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string dispatch_group_id = 1; */
        if (message.dispatchGroupId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string delivery_point_id = 2; */
        if (message.deliveryPointId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deliveryPointId);
        /* uint64 effective_from = 3; */
        if (message.effectiveFrom !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.effectiveFrom);
        /* optional uint64 effective_to = 4; */
        if (message.effectiveTo !== undefined)
            writer.tag(4, WireType.Varint).uint64(message.effectiveTo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.AddDispatchGroupDeliveryPointRequest
 */
export const AddDispatchGroupDeliveryPointRequest = new AddDispatchGroupDeliveryPointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddDispatchGroupDeliveryPointResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.AddDispatchGroupDeliveryPointResponse", [
            { no: 1, name: "delivery_point", kind: "message", T: () => DispatchGroupDeliveryPoint }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.DispatchGroupDeliveryPoint delivery_point */ 1:
                    message.deliveryPoint = DispatchGroupDeliveryPoint.internalBinaryRead(reader, reader.uint32(), options, message.deliveryPoint);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.DispatchGroupDeliveryPoint delivery_point = 1; */
        if (message.deliveryPoint)
            DispatchGroupDeliveryPoint.internalBinaryWrite(message.deliveryPoint, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.AddDispatchGroupDeliveryPointResponse
 */
export const AddDispatchGroupDeliveryPointResponse = new AddDispatchGroupDeliveryPointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveDispatchGroupDeliveryPointRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.RemoveDispatchGroupDeliveryPointRequest", [
            { no: 1, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "effective_from", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroupId = "";
        message.deliveryPointId = "";
        message.effectiveFrom = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dispatch_group_id */ 1:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string delivery_point_id */ 2:
                    message.deliveryPointId = reader.string();
                    break;
                case /* uint64 effective_from */ 3:
                    message.effectiveFrom = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string dispatch_group_id = 1; */
        if (message.dispatchGroupId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string delivery_point_id = 2; */
        if (message.deliveryPointId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deliveryPointId);
        /* uint64 effective_from = 3; */
        if (message.effectiveFrom !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.effectiveFrom);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.RemoveDispatchGroupDeliveryPointRequest
 */
export const RemoveDispatchGroupDeliveryPointRequest = new RemoveDispatchGroupDeliveryPointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveDispatchGroupDeliveryPointResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.RemoveDispatchGroupDeliveryPointResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.RemoveDispatchGroupDeliveryPointResponse
 */
export const RemoveDispatchGroupDeliveryPointResponse = new RemoveDispatchGroupDeliveryPointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchGroupDeliveryPointsRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchGroupDeliveryPointsRequest", [
            { no: 1, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "effective_from_after", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "effective_from_before", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 6, name: "sort", kind: "message", T: () => SortOptions },
            { no: 7, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroupId = "";
        message.deliveryPointId = "";
        message.effectiveFromAfter = 0n;
        message.effectiveFromBefore = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dispatch_group_id */ 1:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string delivery_point_id */ 2:
                    message.deliveryPointId = reader.string();
                    break;
                case /* uint64 effective_from_after */ 3:
                    message.effectiveFromAfter = reader.uint64().toBigInt();
                    break;
                case /* uint64 effective_from_before */ 4:
                    message.effectiveFromBefore = reader.uint64().toBigInt();
                    break;
                case /* common.v1.PaginationRequest pagination */ 5:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* dispatch_group.v1.SortOptions sort */ 6:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* dispatch_group.v1.HydrationOptions hydration */ 7:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string dispatch_group_id = 1; */
        if (message.dispatchGroupId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string delivery_point_id = 2; */
        if (message.deliveryPointId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deliveryPointId);
        /* uint64 effective_from_after = 3; */
        if (message.effectiveFromAfter !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.effectiveFromAfter);
        /* uint64 effective_from_before = 4; */
        if (message.effectiveFromBefore !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.effectiveFromBefore);
        /* common.v1.PaginationRequest pagination = 5; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.SortOptions sort = 6; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* dispatch_group.v1.HydrationOptions hydration = 7; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchGroupDeliveryPointsRequest
 */
export const ListDispatchGroupDeliveryPointsRequest = new ListDispatchGroupDeliveryPointsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchGroupDeliveryPointsResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchGroupDeliveryPointsResponse", [
            { no: 1, name: "delivery_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchGroupDeliveryPoint },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deliveryPoints = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated dispatch_group.v1.DispatchGroupDeliveryPoint delivery_points */ 1:
                    message.deliveryPoints.push(DispatchGroupDeliveryPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated dispatch_group.v1.DispatchGroupDeliveryPoint delivery_points = 1; */
        for (let i = 0; i < message.deliveryPoints.length; i++)
            DispatchGroupDeliveryPoint.internalBinaryWrite(message.deliveryPoints[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchGroupDeliveryPointsResponse
 */
export const ListDispatchGroupDeliveryPointsResponse = new ListDispatchGroupDeliveryPointsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDispatcherRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.CreateDispatcherRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.CreateDispatcherRequest
 */
export const CreateDispatcherRequest = new CreateDispatcherRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDispatcherResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.CreateDispatcherResponse", [
            { no: 1, name: "dispatcher", kind: "message", T: () => Dispatcher }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.Dispatcher dispatcher */ 1:
                    message.dispatcher = Dispatcher.internalBinaryRead(reader, reader.uint32(), options, message.dispatcher);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.Dispatcher dispatcher = 1; */
        if (message.dispatcher)
            Dispatcher.internalBinaryWrite(message.dispatcher, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.CreateDispatcherResponse
 */
export const CreateDispatcherResponse = new CreateDispatcherResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDispatcherRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.GetDispatcherRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.GetDispatcherRequest
 */
export const GetDispatcherRequest = new GetDispatcherRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDispatcherResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.GetDispatcherResponse", [
            { no: 1, name: "dispatcher", kind: "message", T: () => Dispatcher }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.Dispatcher dispatcher */ 1:
                    message.dispatcher = Dispatcher.internalBinaryRead(reader, reader.uint32(), options, message.dispatcher);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.Dispatcher dispatcher = 1; */
        if (message.dispatcher)
            Dispatcher.internalBinaryWrite(message.dispatcher, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.GetDispatcherResponse
 */
export const GetDispatcherResponse = new GetDispatcherResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchersRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchersRequest", [
            { no: 1, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 2, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeDeleted = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.v1.PaginationRequest pagination */ 1:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* bool include_deleted */ 2:
                    message.includeDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* common.v1.PaginationRequest pagination = 1; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool include_deleted = 2; */
        if (message.includeDeleted !== false)
            writer.tag(2, WireType.Varint).bool(message.includeDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchersRequest
 */
export const ListDispatchersRequest = new ListDispatchersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDispatchersResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.ListDispatchersResponse", [
            { no: 1, name: "dispatchers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Dispatcher },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated dispatch_group.v1.Dispatcher dispatchers */ 1:
                    message.dispatchers.push(Dispatcher.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated dispatch_group.v1.Dispatcher dispatchers = 1; */
        for (let i = 0; i < message.dispatchers.length; i++)
            Dispatcher.internalBinaryWrite(message.dispatchers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.ListDispatchersResponse
 */
export const ListDispatchersResponse = new ListDispatchersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatcherRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatcherRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatcherRequest
 */
export const UpdateDispatcherRequest = new UpdateDispatcherRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDispatcherResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.UpdateDispatcherResponse", [
            { no: 1, name: "dispatcher", kind: "message", T: () => Dispatcher }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* dispatch_group.v1.Dispatcher dispatcher */ 1:
                    message.dispatcher = Dispatcher.internalBinaryRead(reader, reader.uint32(), options, message.dispatcher);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* dispatch_group.v1.Dispatcher dispatcher = 1; */
        if (message.dispatcher)
            Dispatcher.internalBinaryWrite(message.dispatcher, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.UpdateDispatcherResponse
 */
export const UpdateDispatcherResponse = new UpdateDispatcherResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDispatcherRequest$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DeleteDispatcherRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DeleteDispatcherRequest
 */
export const DeleteDispatcherRequest = new DeleteDispatcherRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDispatcherResponse$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DeleteDispatcherResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DeleteDispatcherResponse
 */
export const DeleteDispatcherResponse = new DeleteDispatcherResponse$Type();
/**
 * @generated ServiceType for protobuf service dispatch_group.v1.DispatchGroupService
 */
export const DispatchGroupService = new ServiceType("dispatch_group.v1.DispatchGroupService", [
    { name: "CreateDispatchGroup", options: { "google.api.http": { post: "/v1/dispatch-groups", body: "*" } }, I: CreateDispatchGroupRequest, O: CreateDispatchGroupResponse },
    { name: "GetDispatchGroup", options: { "google.api.http": { get: "/v1/dispatch-groups/{id}" } }, I: GetDispatchGroupRequest, O: GetDispatchGroupResponse },
    { name: "ListDispatchGroups", options: { "google.api.http": { get: "/v1/dispatch-groups" } }, I: ListDispatchGroupsRequest, O: ListDispatchGroupsResponse },
    { name: "UpdateDispatchGroup", options: { "google.api.http": { put: "/v1/dispatch-groups/{id}", body: "dispatch_group" } }, I: UpdateDispatchGroupRequest, O: UpdateDispatchGroupResponse },
    { name: "DeleteDispatchGroup", options: { "google.api.http": { delete: "/v1/dispatch-groups/{id}" } }, I: DeleteDispatchGroupRequest, O: DeleteDispatchGroupResponse },
    { name: "RestoreDispatchGroup", options: { "google.api.http": { post: "/v1/dispatch-groups/{id}/restore" } }, I: RestoreDispatchGroupRequest, O: RestoreDispatchGroupResponse },
    { name: "AddGridServiceToDispatchGroup", options: { "google.api.http": { post: "/v1/dispatch-groups/{dispatch_group_id}/grid-services", body: "*" } }, I: AddGridServiceToDispatchGroupRequest, O: AddGridServiceToDispatchGroupResponse },
    { name: "RemoveGridServiceFromDispatchGroup", options: { "google.api.http": { delete: "/v1/dispatch-groups/grid-services/{id}" } }, I: RemoveGridServiceFromDispatchGroupRequest, O: RemoveGridServiceFromDispatchGroupResponse },
    { name: "UpdateDispatchGroupGridService", options: { "google.api.http": { put: "/v1/dispatch-groups/grid-services/{id}", body: "grid_service" } }, I: UpdateDispatchGroupGridServiceRequest, O: UpdateDispatchGroupGridServiceResponse },
    { name: "ListDispatchGroupGridServices", options: { "google.api.http": { get: "/v1/dispatch-groups/{dispatch_group_id}/grid-services" } }, I: ListDispatchGroupGridServicesRequest, O: ListDispatchGroupGridServicesResponse },
    { name: "CreateDispatchIndicator", options: { "google.api.http": { post: "/v1/dispatch-indicators", body: "*" } }, I: CreateDispatchIndicatorRequest, O: CreateDispatchIndicatorResponse },
    { name: "GetDispatchIndicator", options: { "google.api.http": { get: "/v1/dispatch-indicators/{grid_service_id}/{timestamp}" } }, I: GetDispatchIndicatorRequest, O: GetDispatchIndicatorResponse },
    { name: "ListDispatchIndicators", options: { "google.api.http": { get: "/v1/dispatch-indicators" } }, I: ListDispatchIndicatorsRequest, O: ListDispatchIndicatorsResponse },
    { name: "UpdateDispatchIndicator", options: { "google.api.http": { put: "/v1/dispatch-indicators/{grid_service_id}/{timestamp}", body: "*" } }, I: UpdateDispatchIndicatorRequest, O: UpdateDispatchIndicatorResponse },
    { name: "DeleteDispatchIndicator", options: { "google.api.http": { delete: "/v1/dispatch-indicators/{grid_service_id}/{timestamp}" } }, I: DeleteDispatchIndicatorRequest, O: DeleteDispatchIndicatorResponse },
    { name: "AddDispatchGroupDeliveryPoint", options: { "google.api.http": { post: "/v1/dispatch-groups/{dispatch_group_id}/delivery-points-temporal", body: "*" } }, I: AddDispatchGroupDeliveryPointRequest, O: AddDispatchGroupDeliveryPointResponse },
    { name: "RemoveDispatchGroupDeliveryPoint", options: { "google.api.http": { delete: "/v1/dispatch-groups/{dispatch_group_id}/delivery-points-temporal/{delivery_point_id}/{effective_from}" } }, I: RemoveDispatchGroupDeliveryPointRequest, O: RemoveDispatchGroupDeliveryPointResponse },
    { name: "ListDispatchGroupDeliveryPoints", options: { "google.api.http": { get: "/v1/dispatch-groups/{dispatch_group_id}/delivery-points-temporal" } }, I: ListDispatchGroupDeliveryPointsRequest, O: ListDispatchGroupDeliveryPointsResponse },
    { name: "CreateDispatcher", options: { "google.api.http": { post: "/v1/dispatchers", body: "*" } }, I: CreateDispatcherRequest, O: CreateDispatcherResponse },
    { name: "GetDispatcher", options: { "google.api.http": { get: "/v1/dispatchers/{id}" } }, I: GetDispatcherRequest, O: GetDispatcherResponse },
    { name: "ListDispatchers", options: { "google.api.http": { get: "/v1/dispatchers" } }, I: ListDispatchersRequest, O: ListDispatchersResponse },
    { name: "UpdateDispatcher", options: { "google.api.http": { put: "/v1/dispatchers/{id}", body: "*" } }, I: UpdateDispatcherRequest, O: UpdateDispatcherResponse },
    { name: "DeleteDispatcher", options: { "google.api.http": { delete: "/v1/dispatchers/{id}" } }, I: DeleteDispatcherRequest, O: DeleteDispatcherResponse }
]);
//# sourceMappingURL=service.js.map